import { render } from "./ReportDetail.vue?vue&type=template&id=f40abd8c&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"

import "./ReportDetail.vue?vue&type=style&index=0&id=f40abd8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40abd8c"]])

export default __exports__